<button
  type="button"
  class="stitchy-launcher"
  [class.stitchy-launcher--nav]="variant() === 'nav'"
  [attr.aria-label]="label()"
  (click)="clicked.emit()"
>
  <app-icon [name]="head()" [size]="headSize()" />
  @if (activity().icon; as icon) {
    <span
      class="activity-dot activity-icon"
      data-testid="stitchy-launcher-activity"
      [style.background]="activity().background"
      [style.color]="activity().text"
    >
      <app-icon [name]="icon" [size]="statusIconSize()" />
    </span>
  } @else {
    <span class="activity-dot" data-testid="stitchy-launcher-activity" [style.background]="activity().color"></span>
  }
  @if (unseen()) {
    <app-attention-dot class="absolute -top-2 -right-2" />
  }
</button>
